<p-card styleClass="ui-card-shadow" header="{{title}}">
  <p-header *ngIf="clickableHeader"(click)="navigateUri()" class="card-header">     
      <a target="_self" (click)="navigateUri()" title="Workflow">{{dashboardTitle}}</a>
  </p-header>
  <p-table [value]="taskToComplete" 
    [loading]="loading"
    [paginator]="showPaginator" 
    [rows]="10"
    [rowsPerPageOptions]="[10,25,50,100]"
    [totalRecords]="totalRecords"
    paginatorPosition="both"
    (onLazyLoad)="loadPaginatedData($event)"
    [lazy]="true"
    [lazyLoadOnInit] = "false"
    [resetPageOnSort] = "false">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th [pSortableColumn]="'LenderPublicName'">Partnership
          <p-sortIcon [field]="'LenderPublicName'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'LoanNumber'">Loan Number
          <p-sortIcon [field]="'LoanNumber'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'EventName'">Task Name
          <p-sortIcon [field]="'EventName'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'PropertyAddressState'">State
          <p-sortIcon [field]="'PropertyAddressState'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'AssignedPersonLastName'">Person
          <p-sortIcon [field]="'AssignedPersonLastName'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'OpenDate'">Open Date
          <p-sortIcon [field]="'OpenDate'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'DueDate'">Due/Completed
          <p-sortIcon [field]="'DueDate'"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-task>
      <tr>
        <td>{{task.LenderPublicName}}</td>
        <td>{{task.LoanNumber}}</td>
        <td><a
              href="{{getTaskViewUri(task.EventLocation,task.PropertyId, task.TaskInstanceId, task.ParentEventTrackingId)}}"
              target="_self" title="{{task.EventName}}">{{task.EventName | slice:0:15}}<span
              *ngIf="task.EventName.length > 15">...</span></a>
        </td>
        <td>{{task.Address.State}}</td>
        <td><span *ngIf="task.AssignedPersonLastName">{{task.AssignedPersonLastName | slice:0:1}}.
          </span>{{task.AssignedPersonFirstName}}</td>
        <td>{{task?.OpenDate | dateTimeFormat:'MM/dd/yyyy'}}</td>
        <td [class]="taskSvc.getStatusClass(task.TaskStatusId)">{{task?.DueDate | dateTimeFormat:'MM/dd/yyyy'}}</td>
      </tr>
    </ng-template>
  </p-table>
  <p-overlayPanel #showLoanDetails [dismissable]="true" appendTo="body">
    <div *ngIf="taskSelected">
      {{taskSelected.LoanNumber}} -
      {{taskSelected.Address.Address1}}<span
        *ngIf="taskSelected.Address.Address2">,{{taskSelected.Address.Address2}}</span>, {{taskSelected.Address.City}},
      {{taskSelected.Address.State}}, {{taskSelected.Address.PostalCode}}
    </div>
  </p-overlayPanel>
</p-card>